import { render, staticRenderFns } from "./IconDocumentTextOutline.vue?vue&type=template&id=58168e81"
import script from "./IconDocumentTextOutline.vue?vue&type=script&lang=js"
export * from "./IconDocumentTextOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports